var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"theme-search-card-container"},_vm._l((_vm.groups),function(group){return _c('ThemeCard',{key:`group_${group.id}`,attrs:{"group":group}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }